import _ from 'lodash';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { BaseComponent } from '../../../../components/BaseComponent';
import { VBox } from '../../../../components/Box';
import { StepperIcons } from './StepperIcons';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { ChevronRight, ChevronLeft } from 'react-feather';
import cn from 'classnames';
import styles from './Header.module.css';

const COLOR_INACTIVE = '#F1F2FA';

const CreateHeaderWrapper = styled.div`
  background-color: white;
  padding: 24px;
  margin: 3px 0px;
  position: relative;
  width: auto;
  display: flex;

  @media (max-width: 768px) {
    width: 100%;
    margin: 3px 0;
    padding: 12px;
  }
`;

const Container = styled.div`
  display: inline-flex;
  flex-direction: row-reverse;
  height: 75px;
  align-items: center;
  justify-content: space-between;
`;

const Item = styled.div`
  width: 100%;
  height: 75px;
  display: inline-flex;
  align-items: center;
  padding: 0 4px;
  color: white;
  font-weight: 600;

  > div {
    background-color: var(--color-new-primary-hover);
    color: var(--color-new-white);
    align-self: stretch;
    display: flex;
    height: 75px;
    width: 150px;
    padding: 6px 12px;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &:not(.active) > div :hover {
    background-color: var(--color-new-primary);
    color: var(--color-new-white);
  }

  //order is reveresed, first child = last ...
  &:last-child {
    > div {
      padding-left: 0px;
    }
    margin-left: 0px;
  }

  &:not(.active) > div {
    background-color: var( --color-new-light);
    color: var(--color-new-primary);
  }

  .decorator {
    polygon {
      background-color: red;
    }
    height: 75px;
  }
`;

export const StepperCreateHeader = function(props) {
  return (
    <CreateHeaderWrapper className={cn('container-fluid', styles.header)}>
     {props.step > 1 && window.innerWidth <= 768 && <ChevronLeft className={styles.icon} onClick={props.onIncrement} />}
      <Container className="create-header">
        {window.innerWidth > 768 ? (
          _.times(props.steps_quantity, n => (
            <HeaderItem
              onSave={props.onSave}
              getStep={props.getStep}
              model_id={props.model_id}
              steps_quantity={props.steps_quantity}
              model={props.model}
              key={n}
              n={n + 1}
              edit={props.edit}
              labelArr={props.labelArr ? props.labelArr : []}
              fill={props.step == n + 1 ? COLOR_PRIMARY_1 : COLOR_INACTIVE}
              active={props.step == n + 1}
              last={n == props.steps_quantity - 1}
              step={n + 1}
            />
          )).reverse()
        ) : (
          <HeaderItem
            onSave={props.onSave}
            getStep={props.getStep}
            model_id={props.model_id}
            steps_quantity={props.steps_quantity}
            model={props.model}
            n={props.step}
            edit={props.edit}
            labelArr={props.labelArr ? props.labelArr : []}
            step={props.step + 1}
            active={props.step + 1}
          />
        )}
      </Container>
      {props.step < props.steps_quantity && window.innerWidth <= 768 &&  <ChevronRight className={styles.icon} onClick={props.onDecrement} />}
    </CreateHeaderWrapper>
  );
};

class StepperCreateHeaderItem extends BaseComponent {
  handleClick() {
    const model_url = this.props.model === 'vehicle' ? 'vehicles' : 'companies';
    this.props.onSave && this.props.onSave();
    this.props.getStep(this.props.n);
    
  }
  labelArr = this.props.labelArr;
  render() {
    let itemWidth = document.getElementById('pagetop')?.offsetWidth || document.width;
    console.log(itemWidth);

    itemWidth -= 50;
    const props = this.props;

    return (
      <Item
        key={props.n}
        onClick={this.handleClick.bind(this)}
        className={`${props.active ? ' active ' : ''}`}
        width={itemWidth / props.steps_quantity}
      >
        <VBox center className={cn('item', styles.item)}>
          <StepperIcons edit={props.edit} step={props.step} model={props.model} label={this.labelArr[this.props.n - 1]} />
        </VBox>
      </Item>
    );
  }
}

const HeaderItem = withRouter(StepperCreateHeaderItem);
